import React from "react";

export function IEMessage() {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="bg-white px-8 py-4 max-w-lg text-gray-800">
        <h1 className="text-xl font-bold mb-4">
          お使いのブラウザはサポートされていません。
        </h1>
        <p className="mb-8">
          申し訳ありません。「百人会議投票コメントシステム」はInternet Explorerをサポートしていません。
          <br />
          お手数ですがChromeで利用してください。Chromeをお持ちでない方は以下のリンクからダウンロード、インストールをお願いします。
        </p>
        <a
          href="https://www.google.com/intl/ja_jp/chrome/"
          className="px-2 py-1 text-white bg-indigo-500 block flex justify-center items-center flex-col"
        >
          Chromeのダウンロードはこちら
          <br />
          <span className="text-xs block text-gray-200">
            (Chromeの紹介ページを開きます)
          </span>
        </a>
      </div>
    </div>
  );
}
